import type { ElementType } from 'react';

import { InspectionResultEnum } from '@/types/enums/inspection-result.enum';
import { t } from '@/utils/lang';
import Chip from '@mui/material/Chip';

interface StatusChipProps {
    status: InspectionResultEnum | 'default';
    size?: 'small' | 'medium';
    component?: ElementType;
    showChip?: boolean;
}

const ChipInspectionResultStatus = ({
    status,
    size = 'medium',
    component: Component = Chip,
    showChip = true,
}: StatusChipProps) => {
    let label: string;
    let color: 'info' | 'warning' | 'success' | 'error' | 'default';

    const lowerCaseStatus = status?.toLowerCase();

    switch (lowerCaseStatus) {
        case InspectionResultEnum.INCORRECT_OPERATION.toLowerCase():
        case 'incorrect_operation':
            label = 'Sai thao tác';
            color = 'error';
            break;
        case InspectionResultEnum.CORRECT_PROCEDURE.toLowerCase():
        case 'correct_procedure':
            label = 'Đúng quy trình';
            color = 'success';
            break;
        case InspectionResultEnum.MISSING_STEP.toLowerCase():
        case 'missing_step':
            label = 'Thiếu bước';
            color = 'warning';
            break;
        default:
            label = 'Không xác định';
            color = 'default';
            break;
    }

    if (showChip) {
        return (
            <Component
                variant='tonal'
                label={t(label, 'InspectionResultStatus')}
                color={color}
                size={size}
            />
        );
    }

    return {
        label: t(label, 'InspectionResultStatus'),
        color,
    };
};

export default ChipInspectionResultStatus;
